export function toAttributeString(value) {
    if (value && typeof value === 'object' && typeof value.toAttributeString === 'function') {
        return value.toAttributeString();
    }
    else {
        return '' + value;
    }
}
export function toStyleString(value) {
    if (value && typeof value === 'object' && typeof value.toStyleString === 'function') {
        return value.toStyleString();
    }
    else {
        return '' + value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXQSxNQUFNLDRCQUE0QixLQUFVO0lBQzFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksT0FBUSxLQUEyQixDQUFDLGlCQUFpQixLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUM7UUFDL0csTUFBTSxDQUFFLEtBQTJCLENBQUMsaUJBQWlCLEVBQUUsQ0FBQztJQUMxRCxDQUFDO0lBQUMsSUFBSSxDQUFDLENBQUM7UUFDTixNQUFNLENBQUMsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUNwQixDQUFDO0FBQ0gsQ0FBQztBQU1ELE1BQU0sd0JBQXdCLEtBQVU7SUFDdEMsRUFBRSxDQUFDLENBQUMsS0FBSyxJQUFJLE9BQU8sS0FBSyxLQUFLLFFBQVEsSUFBSSxPQUFRLEtBQXVCLENBQUMsYUFBYSxLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUM7UUFDdkcsTUFBTSxDQUFFLEtBQXVCLENBQUMsYUFBYSxFQUFFLENBQUM7SUFDbEQsQ0FBQztJQUFDLElBQUksQ0FBQyxDQUFDO1FBQ04sTUFBTSxDQUFDLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDcEIsQ0FBQztBQUNILENBQUMifQ==